module.exports = __webpack_public_path__ + "img/framework.64427dc1.png";